<template lang="pug">
  .chipModal
    div.chipModal__container.chipModal__header
      h2.chipModal__title O que é e como funciona o eSIM
      p.chipModal__description O eSIM é um chip que é fabricado como parte do aparelho. Já que não é necessário inserir ou remover o chip, basta habilitar no celular. Seu plano do Seguro Viagem inclui {{ numberOfDaysOfTheTrip }} dias de chip internacional - confira abaixo se o seu smartphone conta com a tecnologia eSIM:

    ol
      li.chipModal__brand-item(v-for="(deviceBrand, index) in deviceBrands" :key="index")
        div.chipModal__brand-header(@click="toggleBrand(index)")
          h5 {{ deviceBrand.name }}
          img(
            src="~@/assets/icons/close.svg"
            alt=""
            width="24"
            height="24"
            :class="['chipModal__brand-close', { 'chipModal__brand-close--open': deviceBrandStatus[index] }]"
          )

        transition(@enter="setHeight" @before-leave="clearHeight")
          div.chipModal__container.chipModal__brand-collapser(v-show="deviceBrandStatus[index]")
            div
              ol.chipModal__model-list
                li.chipModal__model-item(v-for="(model, index) in deviceBrand.models" :key="index")
                  img.chipModal__model-icon(
                    src="~@/assets/icons/icon-check.svg"
                    alt=""
                    width="24"
                    height="24"
                  )
                  | {{ model }}

              p.chipModal__model-disclaimer(v-if="deviceBrand.disclaimer") {{ deviceBrand.disclaimer }}
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import cpButton from '@/components/ui/Button'
import deviceBrands from './data.js'

export default {
  components: {
    cpButton
  },
  data: () => ({
    deviceBrands,
    openDeviceBrand: []
  }),
  computed: {
    ...mapState('quotation', ['endDate', 'initialDate']),
    numberOfDaysOfTheTrip () {
      const start = moment(this.initialDate, 'YYYY-MM-DD')
      const end = moment(this.endDate, 'YYYY-MM-DD')

      return moment.duration(end.diff(start)).add(1, 'days').asDays()
    },
    deviceBrandStatus () {
      return this.deviceBrands.map((_, index) =>
        this.openDeviceBrand.includes(index)
      )
    }
  },
  methods: {
    toggleBrand (deviceBrandIndex) {
      if (this.openDeviceBrand.includes(deviceBrandIndex)) {
        this.openDeviceBrand.splice(this.openDeviceBrand.indexOf(deviceBrandIndex), 1)
      } else {
        this.openDeviceBrand.push(deviceBrandIndex)
      }
    },
    setHeight (el) {
      el.style.height = `${el.childNodes[0].offsetHeight}px`
    },
    clearHeight (el) {
      el.style.height = '0'
    }
  }
}
</script>
<style lang="scss">
@import "~@/style/ui/variables";
.chipModal {
  font-family: $oscine-font-family;
  padding-top: 72px;
  width: 100%;

  &__container {
    padding: 0 24px;
  }

  &__title {
    color: #373739;
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 24px;
  }

  &__description {
    color: #535355;
    font-size: 16px;
    font-family: $rubik-font-family;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 16px;
  }

  &__brand-item {
    color: #444444;
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
    list-style: none;

    &:not(:last-child) {
      border-bottom: 1px solid #D5D5D7;
    }
  }

  &__brand-header {
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    padding: 16px 24px;
  }

  &__brand-close {
    flex-shrink: 0;
    height: 24px;
    transform: rotateZ(45deg);
    transition: transform 0.2s linear;

    &--open {
      transform: rotateZ(0deg);
    }
  }

  &__brand-collapser {
    height: 0;
    overflow: hidden;
    transition: height 0.2s linear;
    margin-bottom: 16px;
  }

  &__model-list {
    color: #444444;
    font-size: 16px;
    font-family: $rubik-font-family;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  &__model-item {
    align-items: center;
    display: flex;
    margin-bottom: 16px;
  }

  &__model-icon {
      height: 24px;
      margin-right: 8px;
      width: 24px;
    }

  &__model-disclaimer {
    color: #535355;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }
}
</style>
